/* Europe Mark: reliable mobile menu close/reset and reopen fix. */
(function () {
  'use strict';

  if (window.__emShrineMenuReopenV2) return;
  window.__emShrineMenuReopenV2 = true;

  var observerStarted = false;

  function patchDrawer(drawer) {
    if (!drawer || drawer.__emMenuReopenV2) return;

    var mainDetails = drawer.mainDetailsToggle || drawer.querySelector('details.menu-drawer-container');
    if (!mainDetails) return;

    var firstChild = mainDetails.firstElementChild;
    var summary = firstChild && firstChild.tagName === 'SUMMARY' ? firstChild : mainDetails.querySelector('summary');
    var breakpoint = drawer.dataset.breakpoint || 'mobile';
    var originalCloseAnimation = typeof drawer.closeAnimation === 'function'
      ? drawer.closeAnimation.bind(drawer)
      : null;
    var closeToken = 0;

    function clearDrawerState() {
      mainDetails.classList.remove('menu-opening');
      mainDetails.removeAttribute('open');

      if (summary) summary.setAttribute('aria-expanded', 'false');

      mainDetails.querySelectorAll('details[open]').forEach(function (details) {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });

      mainDetails.querySelectorAll('.submenu-open').forEach(function (item) {
        item.classList.remove('submenu-open');
      });

      document.body.classList.remove('overflow-hidden-' + breakpoint);

      if (typeof removeTrapFocus === 'function') {
        removeTrapFocus(summary || false);
      }
    }

    drawer.closeAnimation = function (details) {
      if (details === mainDetails || details === this.mainDetailsToggle) {
        closeToken += 1;
        clearDrawerState();
        return;
      }

      if (originalCloseAnimation) {
        return originalCloseAnimation(details);
      }
    };

    drawer.addEventListener('click', function (event) {
      var target = event.target;
      var closeButton = target && target.closest
        ? target.closest('.menu-drawer__close-menu-btn')
        : null;

      if (!closeButton) return;

      var token = ++closeToken;

      window.setTimeout(function () {
        if (token === closeToken) clearDrawerState();
      }, 0);

      window.setTimeout(function () {
        if (token === closeToken && !mainDetails.hasAttribute('open')) {
          clearDrawerState();
        }
      }, 450);
    }, true);

    mainDetails.addEventListener('toggle', function () {
      if (mainDetails.hasAttribute('open')) {
        closeToken += 1;
      } else {
        clearDrawerState();
      }
    });

    drawer.__emMenuReopenV2 = true;
  }

  function patchAll(root) {
    var scope = root && root.querySelectorAll ? root : document;

    if (scope.matches && scope.matches('header-drawer')) {
      patchDrawer(scope);
    }

    scope.querySelectorAll('header-drawer').forEach(patchDrawer);
  }

  function start() {
    patchAll(document);

    if (observerStarted) return;
    observerStarted = true;

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) patchAll(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  customElements.whenDefined('header-drawer').then(start);
})();
